module.exports = __webpack_public_path__ + "static/img/zhongjin.b8ae285.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/market/zhongjin.png
// module id = 3P7H
// module chunks = 2